/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketStatusMappingOptionsModel } from '../../models/support-ticket-status-mapping-options-model';

export interface Options$Params {
}

export function Options(http: HttpClient, rootUrl: string, params?: Options$Params, context?: HttpContext): Observable<StrictHttpResponse<SupportTicketStatusMappingOptionsModel>> {
  const rb = new RequestBuilder(rootUrl, Options.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SupportTicketStatusMappingOptionsModel>;
    })
  );
}

Options.PATH = '/api/TicketStatusMappings/Options';
